<div class="bg-custom">
  <div class="container">
    <section>
      <div class="mb-3">
        <a
          (click)="backToMyLetters()"
          (keydown.enter)="backToMyLetters()"
          (keydown.space)="$event.preventDefault(); backToMyLetters()"
          role="button"
          tabindex="0"
          [attr.aria-label]="'BACK_TO_MY_LETTERS' | globalTranslate"
        >
          <i class="fa fa-arrow-left me-2" aria-hidden="true"></i>
          <span>{{ "BACK_TO_MY_LETTERS" | globalTranslate }}</span>
        </a>
      </div>
      <div></div>
      @if (!isLoading && nodBudgetResponse) {
      <div>
        <h2 class="section-header">
          {{ "SELECT_HOUSEHOLD_MEMBER_HEADER" | globalTranslate }}
        </h2>
        <hr />
        <p>{{ "SELECT_HOUSEHOLD_MEMBER_TEXT" | globalTranslate }}</p>
        <form [formGroup]="selectionForm">
          <div class="row align-items-center">
            <div class="col-12">
              <label for="memberSelect" class="form-label mb-md-0"
                >{{ "MEMBER" | globalTranslate }}:</label
              >
            </div>
            <div class="member_selection">
              <div class="col-12 col-md-7 mb-2 mb-md-0">
                <select
                  nhTranslate
                  name="member"
                  [attr.aria-label]="'MEMBER' | globalTranslate"
                  [items]="householdMembers"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="member"
                  id="memberSelect"
                ></select>
              </div>
              <div
                class="col-5 pt-3 pt-lg-0 pt-md-0 col-md-3 col-lg-2 button_auto"
              >
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="onMemberSelect()"
                  [disabled]="!selectionForm.get('member')?.value"
                  [attr.aria-label]="'SELECT' | globalTranslate"
                >
                  {{ "SELECT" | globalTranslate }}
                </button>
              </div>
            </div>
          </div>
          <br />
          <!-- Category of Eligibility Selection -->
          @if (selectedMember && eligibilityCategories.length > 0) {
          <div class="row align-items-center">
            <div class="col-12 mb-2">
              <label for="categorySelect" class="form-label mb-md-0"
                >{{ "CATEGORY_OF_ELIGIBILITY" | globalTranslate }}:</label
              >
            </div>
            <p
              [innerHTML]="'SELECT_HOUSEHOLD_MEMBER_DESC' | globalTranslate"
            ></p>
            <div class="coverage_category">
              <div class="col-12 col-md-7 mb-2 mb-md-0">
                <select
                  nhTranslate
                  name="category"
                  [attr.aria-label]="
                    'CATEGORY_OF_ELIGIBILITY' | globalTranslate
                  "
                  [items]="eligibilityCategories"
                  bindLabel="name"
                  bindValue="code"
                  formControlName="coverageCategory"
                  id="categorySelect"
                ></select>
              </div>
              <div
                class="col-5 pt-3 pt-lg-0 pt-md-0 col-md-3 col-lg-2 button_auto"
              >
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="onCategorySelect()"
                  [disabled]="!selectionForm.get('coverageCategory')?.value"
                  [attr.aria-label]="'SELECT' | globalTranslate"
                >
                  {{ "SELECT" | globalTranslate }}
                </button>
              </div>
            </div>
          </div>
          }
          <br />
        </form>
        <!-- Alert: No Budget Information Available -->
        @if (selectedMember && showNoBudgetAlert) {
        <div>
          <div class="row mt-4 mb-2">
            <div class="col message">
              <p [innerHTML]="'NO_BUDGET_INFO_MESSAGE' | globalTranslate"></p>
            </div>
          </div>
        </div>
        } @if (showBudgetCalculation) {
        <div>
          <nh-budget-calculation
            [memberName]="selectedMember?.name"
            [budgetData]="budgetData"
            (onNavigateToSubscreen)="saveState()"
          ></nh-budget-calculation>
        </div>
        }
      </div>
      } @if (!isLoading && hasError) {
      <div>
        <div class="row mt-4 mb-2">
          <div class="col mb-3 mt-3 message">
            <p [innerHTML]="'NOD_ERROR' | globalTranslate"></p>
          </div>
        </div>
      </div>
      }
    </section>
  </div>
</div>